import React from "react";
import {
  View,
  Text,
  Modal,
  TouchableOpacity,
  ActivityIndicator,
  StyleSheet,
} from "react-native";
import { AlertCircle } from "lucide-react";
import { DeleteConfirmModalProps } from "../../types/VoiceNotes";

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  visible,
  deleting,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={styles.modalOverlay}>
        <View style={styles.modalContent}>
          <Text style={styles.modalTitle}>Delete Voice Note</Text>
          <Text style={styles.modalSubtitle}>
            Are you sure you want to delete this note? This action cannot be
            undone.
          </Text>

          <View style={styles.deleteWarningContainer}>
            <AlertCircle size={20} color="#E53935" />
            <Text style={styles.deleteWarningText}>
              All note content and audio will be permanently deleted.
            </Text>
          </View>

          <View style={styles.modalActions}>
            <TouchableOpacity
              style={styles.cancelButton}
              onPress={onClose}
              disabled={deleting}
            >
              <Text style={styles.cancelButtonText}>Cancel</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[
                styles.deleteConfirmButton,
                deleting && styles.disabledButton,
              ]}
              onPress={onConfirm}
              disabled={deleting}
            >
              {deleting ? (
                <ActivityIndicator size="small" color="#FFFFFF" />
              ) : (
                <Text style={styles.deleteConfirmButtonText}>Delete</Text>
              )}
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  modalContent: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: 24,
    width: "100%",
    maxWidth: 400,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "600",
    color: "#333333",
    marginBottom: 8,
  },
  modalSubtitle: {
    fontSize: 16,
    color: "#666666",
    marginBottom: 20,
  },
  deleteWarningContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#FFF2F0",
    padding: 12,
    borderRadius: 6,
    marginTop: 8,
    marginBottom: 20,
  },
  deleteWarningText: {
    fontSize: 14,
    color: "#E53935",
    marginLeft: 8,
    flex: 1,
  },
  modalActions: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  cancelButton: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F2F2F2",
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 6,
    marginRight: 8,
  },
  cancelButtonText: {
    fontSize: 14,
    color: "#555555",
  },
  deleteConfirmButton: {
    backgroundColor: "#E53935",
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 6,
    minWidth: 80,
    alignItems: "center",
  },
  deleteConfirmButtonText: {
    fontSize: 14,
    color: "#FFFFFF",
    fontWeight: "500",
  },
  disabledButton: {
    opacity: 0.7,
  },
});

export default DeleteConfirmModal;
